import React, { ChangeEvent, FC } from 'react'
import { InputGroup } from '@blueprintjs/core'
import cx from 'classnames'
import { Icon } from '@ui'
import isEmpty from 'lodash/isEmpty'
import css from './searchField.module.scss'

type PropsT = {
  value: string
  className?: string
  onChange: (searchQuery: string) => void
  onClickClearSearch: () => void
}

const SearchField: FC<React.PropsWithChildren<PropsT>> = ({
  className,
  value,
  onChange,
  onClickClearSearch,
}) => {
  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value.toLocaleLowerCase())
  }

  return (
    <InputGroup
      fill
      data-test="floor-selection-search-test"
      className={cx(css.search_field, className)}
      autoFocus={true}
      placeholder="Find a floor, building, or location"
      value={value}
      onChange={onValueChange}
      leftIcon={isEmpty(value) ? 'search' : undefined}
      data-input="location_search"
      rightElement={
        value ? (
          <button onClick={onClickClearSearch}>
            <Icon name="times" />
          </button>
        ) : undefined
      }
    />
  )
}

export default SearchField
